import { render, staticRenderFns } from "./Trivia8.vue?vue&type=template&id=10e02fe9&scoped=true&"
import script from "./Trivia8.vue?vue&type=script&lang=js&"
export * from "./Trivia8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e02fe9",
  null
  
)

export default component.exports